import type { TypeSTTConfigForm } from '@intone/shared';
import { ModelField, LanguageField, PromptField } from './Fields';

export type Props = {
  currentConfig: TypeSTTConfigForm;
  updateConfig: (field: keyof TypeSTTConfigForm, value: any) => void;
};

export function AzureOpenaiFields({ currentConfig, updateConfig }: Props) {
  const modelList = [
    { label: 'Whisper', value: 'whisper' },
    { label: 'gpt-4o-transcribe', value: 'gpt-4o-transcribe' },
    { label: 'gpt-4o-mini-transcribe', value: 'gpt-4o-mini-transcribe' },
  ];
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <ModelField
          value={currentConfig.model}
          onUpdate={(value) => updateConfig('model', value)}
          modelList={modelList}
        />
        <LanguageField value={currentConfig.language} onUpdate={(value) => updateConfig('language', value)} />
      </div>
      <PromptField value={currentConfig.prompt} onUpdate={(value) => updateConfig('prompt', value)} />
    </div>
  );
}